export default __webpack_public_path__ + "7dd49631d09de2fa46bc265b32c917ce.png";